import { render, staticRenderFns } from "./DetailResidentComplex.vue?vue&type=template&id=60d82987&scoped=true"
import script from "./DetailResidentComplex.vue?vue&type=script&lang=js"
export * from "./DetailResidentComplex.vue?vue&type=script&lang=js"
import style0 from "./DetailResidentComplex.vue?vue&type=style&index=0&id=60d82987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d82987",
  null
  
)

export default component.exports